import { NgModule } from '@angular/core';
import { PageNotFoundRoutingModule } from './page-not-found-routing.module';

@NgModule({
  imports: [PageNotFoundRoutingModule],
})
export class PageNotFoundModule {}
